import { combineReducers, } from 'redux';
import tab from './tab';
import auth from './auth';
import navigation from './navigation';

const appReducers = combineReducers({
  tab,
  auth,
  navigation,
});

const rootReducer = (state, action) => {
  const _state = { ...state, };
  return appReducers(_state, action);
};

export default rootReducer;
